import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxySnackbarModule } from '@vendasta/galaxy/snackbar-service';
import { TemplateApiService } from '../../core/template';
import { PublishTemplateComponent } from './publish-template-card.component';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    TranslateModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatDialogModule,
    MatSlideToggleModule,
    GalaxySnackbarModule,
  ],
  declarations: [PublishTemplateComponent],
  exports: [PublishTemplateComponent],
  providers: [TemplateApiService],
})
export class PublishTemplateModule {}
